module.exports = __webpack_public_path__ + "img/pollings-vs-webhook.f7afc7b8.svg";